import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    document.documentElement.style.setProperty('--banner-height', '40px')
  }

  disconnect() {
    document.documentElement.style.setProperty('--banner-height', '0')
  }
}
